module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('grid-x', {
    attrs: {
      "col": "1fr 1fr",
      "row": "1fr",
      "gap": "2em"
    }
  }, [_c('div', {
    staticClass: "col-1"
  }, [_c('h3', [_vm._v("Categories")]), _vm._v(" "), _c('div', {
    staticClass: "widget-buttons"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.updateCacheCategories()
      }
    }
  }, [_vm._v("Update Category Cache")])]), _vm._v(" "), _c('ul', [_vm._l((_vm.categories), function(cat, key) {
    return [_c('li', {
      key: key,
      class: _vm.activeClass(cat, _vm.currentCat),
      on: {
        "click": function($event) {
          _vm.currentCat = cat;
          _vm.currentCatObj = cat;
        }
      }
    }, [_vm._v(_vm._s(cat.name))]), _vm._v(" "), _vm._l((cat.subcategories), function(subcat, subkey) {
      return _c('li', {
        key: key + '-' + subkey,
        class: _vm.activeClass(subcat, _vm.currentCat),
        on: {
          "click": function($event) {
            _vm.currentCat = subcat;
            _vm.currentCatObj = cat;
          }
        }
      }, [_vm._v(_vm._s(cat.name) + " || " + _vm._s(subcat.name))])
    })]
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('h3', [_vm._v("Podcast")]), _vm._v(" "), _c('div', {
    staticClass: "widget-buttons"
  }, [_c('button', {
    on: {
      "click": _vm.addPodcast
    }
  }, [_vm._v("Add podcast")])]), _vm._v(" "), _vm._l((_vm.currentCat.podcasts), function(podcast, podkey) {
    return _c('div', {
      key: podkey,
      staticClass: "flex-row"
    }, [_c('div', {
      staticClass: "input-box down-caret"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (podcast.playlist),
        expression: "podcast.playlist"
      }],
      key: '--' + podkey,
      ref: "addPodcastSelector",
      refInFor: true,
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(podcast, "playlist", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          _vm.selected()
        }],
        "focus": function($event) {
          _vm.changeColor()
        }
      }
    }, [_c('option', {
      attrs: {
        "disabled": "",
        "value": ""
      }
    }, [_vm._v("Select a podcast")]), _vm._v(" "), _vm._l((_vm.podcasts), function(item, optionkey) {
      return _c('option', {
        key: optionkey,
        domProps: {
          "value": {
            slug: item['.key'],
            title: item.title
          }
        }
      }, [_vm._v(_vm._s(item.title))])
    })], 2)]), _vm._v(" "), _c('div', {
      staticClass: "widget-buttons"
    }, [_c('button', {
      on: {
        "click": function($event) {
          _vm.currentCat.podcasts.splice(podkey, 1)
        }
      }
    }, [_vm._v("Remove")]), _vm._v(" "), _c('button', {
      on: {
        "click": _vm.saveCurrentCat
      }
    }, [_vm._v("Save")])])])
  })], 2)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a5be9d8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/categories.vue
// module id = 668
// module chunks = 1